import { ArrayField, DateField, FunctionField, TextField } from 'react-admin';
import { path } from '@/pages/Candidate/view/tables/WorkerDocumentsTable/constants';
import { WorkerDocumentsTableProps } from '@/pages/Candidate/view/tables/WorkerDocumentsTable/types';
import { LinkStyled, SecondaryDatagridStyled } from '@/styles/overrides';
import { FCRAWorker } from '@/types/turn-api';

const WorkerDocumentsTable = ({ source }: WorkerDocumentsTableProps) => {
  return (
    <ArrayField source={source}>
      <SecondaryDatagridStyled bulkActionButtons={false} className="secondary-table" rowClick={false}>
        <TextField source={path('type')} label="Doc Type" sortable={false} />
        <FunctionField
          label="Doc URL"
          sortable={false}
          render={(row: FCRAWorker.Document) => (
            <LinkStyled href={row.url} target="_blank" rel="noopener noreferrer">
              Download {row.type}
            </LinkStyled>
          )}
        />
        <DateField label="Created At" sortable={false} source={path('created_at')} />
        <TextField label="Recheck ID" sortable={false} source={path('recheck_id')} />
      </SecondaryDatagridStyled>
    </ArrayField>
  );
};

export default WorkerDocumentsTable;
